import Config from './../../config/';

const initialState = {
    current: Config.language,
    items: [],
    select: [],
    languageOverviewItems: [],
    loading: true
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case 'SET_LANGUAGES':
            const select = [];

            let found = false;
            let currentLang = state.current;
            let firstLang = state.current;

            if (payload.languages.length > 0) {
                firstLang = payload.languages[0].code;
            }

            payload.languages.forEach((language) => {
                if (currentLang === language.code) {
                    found = true;
                }
                select.push({
                    id: language.code,
                    title: language.title
                });
            });

            return {
                ...state,
                items: payload.languages,
                select: select,
                current: found ? currentLang : firstLang
            };

        case 'SET_LANGUAGE':
            return {
                ...state,
                current: payload.language
            };

        case 'LANGUAGE_OVERVIEW_LOADING':
            return {
                ...state,
                loading: true
            };

        case 'LANGUAGE_OVERVIEW_SUCCESS':
            return {
                ...state,
                languageOverviewItems: action.payload.data,
                loading: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/core/store/reducers/language.js